import { supabase } from './supabase';

/**
 * Get the redirect URL for OAuth callbacks
 * Uses VITE_SITE_URL if set (for production), otherwise uses window.location.origin
 */
export const getRedirectTo = (): string => {
    const siteUrl = import.meta.env.VITE_SITE_URL;
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    const base = siteUrl || origin;
    return `${base}/auth/callback`;
};

/**
 * Sign in with Google OAuth
 * Redirects user to Google, then back to /auth/callback
 */
export async function signInWithGoogle() {
    const redirectTo = getRedirectTo();
    
    if (import.meta.env.DEV) {
        console.log('[AUTH] Initiating Google OAuth login, redirectTo:', redirectTo);
    }
    
    return supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
            redirectTo,
            queryParams: {
                access_type: 'offline',
                prompt: 'consent',
            },
        }
    });
}
